export let contractDefault = {
  id: "",
  docType: "",
  autoNumbering: true,
  identifier: "",
  dateFrom: "",
  dateTo: "",
  conclusionPlace: "",
  companyRepresentative: "",
  positionName: "",
  workPlace: "",
  employmentConditions: "",
  workStartDate: "",
  contractType: {id: 0},
  businessPartner: {id: 0},
  employee: {id: 0},
  hiringCompany: {id: 0},
  defaultForScheduling: false,
  notes: "",
  legalPerson: {id: 0},
  status: "",
  number: 0,
  year: 0,
  month: 0,
  symbol: "",
  zusBasis: {id: 0},
  workingTime: {id: 0},
  billingType: "",
  hourlyRate: 0.00,
  monthlyRate: 0.00,
  netHourlyRate: "",
  netMonthlyRate: "",
  plannedSeveranceCost: "",
  severanceNotes: ""
}


export let employeePositionDefault = {
  id: "",
  position: {id: 0},
  comments: "",
  rateSource: "",
  rateBillingType: "HOURLY",
  hourlyRate: "",
  netHourlyRate: "",
  monthlyRate: "",
  netMonthlyRate: "",
  evaluation: "",
  evaluationDate: "",
  evaluationById: 0,
  evaluationDescription: "",
  active: true,
  EID: 0
}


export let employeeCertificationDefault = {
  id: "",
  EID: 0,
  name: "",
  validFrom: "",
  validTo: "",
  isValid: null,
  noExpirationDate: false,
  evaluationDate: "",
  certificationType: {id: 0},
  comments: "",
  issuedBy: 0,
  issueDate: ""
}


export let employeeMedExamDefault = {
  id: "",
  EID: 0,
  medicalExaminationType: {id: 0},
  examinationDate: "",
  comments: "",
  positive: false,
  expirationDate: ""
}


export let employeeAbsenceDefault = {
  id: "",
  EID: 0,
  absenceType: {id: 0},
  dateFrom: "",
  dateTo: "",
  comments: "",
  positive: false,
  supervisorID: ""
}


export let employeeAvailabilityDefault = {
  id: "",
  EID: 0,
  dateFrom: "",
  dateTo: "",
  type: "AVAILABLE",
  timeFrom: "",
  timeTo: "",
  recurrence: "NONE",
  daysOfWeek: [],
  comments: "",
  version: null,
}

export let employeeTrainingDefault = {
  id: "",
  EID: 0,
  assignedDate: "",
  dateFrom: "",
  dateTo: "",
  testDueDate: "",
  evaluation: "",
  evaluationDate: "",
  evaluationById: 0,
  evaluationDescription: "",
  cost: 0,
  completed: false,
  verificationDueDate: "",
  verificationCompleted: false,
  verificationDate: "",
  training: {id: 0},
  trainerID: 0,
  comments: ""
}

export let employeeCommendationDefault = {
  id: "",
  EID: 0,
  createdBy: 0,
  creationDate: "",
  updatedBy: 0,
  lastUpdateDate: "",
  commendation: {id: 0},
  incidentDate: "",
  supervisorID: 0,
  comments: ""
}

export let employeeInfractionDefault = {
  id: "",
  EID: 0,
  createdBy: 0,
  creationDate: "",
  updatedBy: 0,
  lastUpdateDate: "",
  infraction: {id: 0},
  incidentDate: "",
  supervisorID: 0,
  comments: ""
}


export let hiringStageDefault = {
  id: "",
  name: "",
  shortName: "",
  description: "",
  color: "",
  departmentRequired: false,
  positionRequired: false
};

export let zusAccidentBranchDefault = {
  id: "",
  name: "",
  defaultBranch: false,
  code: "",
  active: false
}


export let zusTypeDefault = {
  id: "",
  name: "",
  shortName: "",
  description: "",
  color: "white",
  retirement: true,
  disability: true,
  employerRetirement: "",
  employerDisability: "",
  krusEmployerContributionPercent: "",
  sickness: true,
  accident: true,
  zusAccidentBranch: {id: 0},
  health: true,
  labourFund: true,
  solidarity: true,
  guaranteedEmployeeBenefits: true
};


export let zusRateDefault = {
  id: "",
  name: "",
  shortName: "",
  description: "",
  year: 0,
  validFrom: "",
  validTo: "",
  retirement: true,
  disability: true,
  employerRetirement: "",
  employerDisability: "",
  krusEmployerContributionPercent: "",
  studentPupilEmployerContributionPercent: "",
  sickness: true,
  defaultAccidentRate: "",
  accidentRates: [],
  health: true,
  labourFund: true,
  solidarity: true,
  guaranteedEmployeeBenefits: true,
  retirementDisabilityCap:0,
  otherLimit:0,
  averageSalary:0,
  minSalary:0,
  minHealthBase:0,
  smallZusBase:0
};

export let timeCardDefault = {
  id: "",
  cardId: 0,
  pin: 0,
  notes: "",
  employeeId: 0,
  active: false,
  valid: true
};



export let skillDefault = {
  id: "",
  name: "",
  shortName: "",
  description: "",
  color: "",
  weight: 0
};



export let documentNumberingPatternDefault = {
  id: "",
  year: 0,
  symbol: "",
  yearFormat: "rrrr",
  monthFormat: "mm",
  pattern: "",
  continuousNumbering: false,
  contractType: {id: 0},
  locked: false
};


export let employeeCompactedDefault = {
  bankAccountNumber: "",
  bankName: "",
  citizenship: "Polska",
  disabilityDegree: "brak",
  retired: false,
  pensioner: false,
  familyHealthInsurance: false,
  bankAccountOwnedByEmployee: true,
  bankAccountHolderName: "",
  bankAccountThirdPartyConsent: false,
  bankAccountConsentDate: "",
  dateOfBirth: "",
  evaluation: "",
  fathersName: "",
  firstName: "",
  gender: {id:0},
  iceContact: "",
  id: "",
  lastName: "",
  login: "",
  maidenName: "",
  mothersName: "",
  maritalStatus: {id:0},
  nip: "",
  oldPassword: "",
  password: "",
  pesel: "",
  placeOfBirth: "",
  companyEmail: "",
  primaryPhone: "",
  secondName: "",
  secondaryEmail: "",
  secondaryPhone: "",
  type: "",
  userRoles: [],
  userRoleDTOS: [],
  photos: "",
  createDate:"",
  lastUpdateDate:"",
  createdBy:"",
  updatedBy:"",
  nfzBranch: {id:0},
  taxOffice: {id:0},
  student: false,
  pupil: false,
  krus: false,
  studentId: "",
  unwanted: false,
  unwantedReason:"",
  parentalConsent: false,
  enabled: true,
  hiringStage: {id: 0},
  primaryAddressStreet: "",
  primaryAddressStreetNumber: "",
  primaryAddressPostalCode: "",
  primaryAddressCity: "",
  primaryAddressVoivodeship: {id: 0},
  primaryAddressCounty: "",
  primaryAddressCommune: "",
  primaryAddressCountry: {id: 0},
  secondaryAddressStreet: "",
  secondaryAddressStreetNumber: "",
  secondaryAddressPostalCode: "",
  secondaryAddressCity: "",
  secondaryAddressVoivodeship: {id: 0},
  secondaryAddressCounty: "",
  secondaryAddressCommune: "",
  secondaryAddressCountry: {id: 0},
  identityCardType: {id: 0},
  identityCardId: "",
  identityCardIssueDate: "",
  identityCardExpiryDate: "",
  issuedBy: "",
  issueLocation: "",
  employeePositions: [],
  employeeSoftSkills: [],
  employeeTrainings: [],
  employeeCommendations: [],
  employeeInfractions: [],
  employeeCertifications: [],
  employeeMedExams: [],
  employeeAbsences: [],
  missingTrainings: [],
  department: {id: 0},
  position: {id: 0},
  communicationByEmail: true,
  communicationBySMS: false,
  hiringCompany: {id: 0},
  scheduleMinWeeklyHours: null,
  scheduleMaxWeeklyHours: null,
  scheduleRequiredDaysOffPerWeek: null,
  scheduleMaxConsecutiveWorkDays: null,
  archived: false,
  archivedAt: null,
  archivedReason: "",
  appUser: false
}

export let employeeDefault = {
  bankAccountNumber: "",
  bankName: "",
  citizenship: "Polska",
  disabilityDegree: "brak",
  retired: false,
  pensioner: false,
  familyHealthInsurance: false,
  bankAccountOwnedByEmployee: true,
  bankAccountHolderName: "",
  bankAccountThirdPartyConsent: false,
  bankAccountConsentDate: "",
  dateOfBirth: "",
  evaluation: "",
  fathersName: "",
  firstName: "",
  gender: {id:0},
  iceContact: "",
  id: "",
  lastName: "",
  login: "",
  maidenName: "",
  mothersName: "",
  maritalStatus: {id:0},
  nip: "",
  oldPassword: "",
  password: "",
  pesel: "",
  placeOfBirth: "",
  companyEmail: "",
  primaryPhone: "",
  secondName: "",
  privateEmail: "",
  secondaryPhone: "",
  type: "",
  userRoles: [],
  userRoleDTOS: [],
  photos: "",
  createDate:"",
  lastUpdateDate:"",
  createdBy:"",
  updatedBy:"",
  nfzBranch: {id:0},
  taxOffice: {id:0},
  student: false,
  pupil: false,
  krus: false,
  studentId: "",
  unwanted: false,
  unwantedReason:"",
  parentalConsent: false,
  enabled: true,
  hiringStage: {id: 0},
  primaryAddressStreet: "",
  primaryAddressStreetNumber: "",
  primaryAddressPostalCode: "",
  primaryAddressCity: "",
  primaryAddressVoivodeship: {id: 0},
  primaryAddressCounty: "",
  primaryAddressCommune: "",
  primaryAddressCountry: {id: 0},
  secondaryAddressStreet: "",
  secondaryAddressStreetNumber: "",
  secondaryAddressPostalCode: "",
  secondaryAddressCity: "",
  secondaryAddressVoivodeship: {id: 0},
  secondaryAddressCounty: "",
  secondaryAddressCommune: "",
  secondaryAddressCountry: {id: 0},
  identityCardType: {id: 0},
  identityCardId: "",
  identityCardIssueDate: "",
  identityCardExpiryDate: "",
  issuedBy: "",
  issueLocation: "",
  employeePositions: [],
  employeeSoftSkills: [],
  employeeTrainings: [],
  employeeCommendations: [],
  employeeInfractions: [],
  employeeCertifications: [],
  employeeMedExams: [],
  employeeAbsences: [],
  missingTrainings: [],
  department: {id: 0},
  position: {id: 0},
  communicationByEmail: true,
  communicationBySMS: false,
  hiringCompany: {id: 0},
  timeCardId: "",
  timeCard: {},
  contractStatus: "",
  contractReference: "",
  latestContract: {},
  latestContractDisp: "",
  availableOnlyWorkingDays: false,
  availableOnlyWeekends: false,
  scheduleMinWeeklyHours: null,
  scheduleMaxWeeklyHours: null,
  scheduleRequiredDaysOffPerWeek: null,
  scheduleMaxConsecutiveWorkDays: null,
  employeeAvailabilities: [],
  employeeSkills: "",
  archived: false,
  archivedAt: null,
  archivedReason: "",
  appUser: false
}


export let employeeProfileDefault = {
  bankAccountNumber: "",
  bankAccountOwnedByEmployee: true,
  bankAccountHolderName: "",
  bankAccountThirdPartyConsent: false,
  bankAccountConsentDate: "",
  dateOfBirth: "",
  evaluation: "",
  fathersName: "",
  firstName: "",
  gender: "",
  iceContact: "",
  id: "",
  lastName: "",
  login: "",
  maidenName: "",
  mothersName: "",
  maritalStatus: "",
  nip: "",
  oldPassword: "",
  password: "",
  pesel: "",
  placeOfBirth: "",
  companyEmail: "",
  primaryPhone: "",
  secondName: "",
  privateEmail: "",
  secondaryPhone: "",
  type: "",
  userRoles: "",
  photos: "",
  createDate:"",
  lastUpdateDate:"",
  createdBy:"",
  updatedBy:"",
  nfzBranch: "",
  taxOffice: "",
  student: false,
  pupil: false,
  krus: false,
  studentId: "",
  unwanted: false,
  unwantedReason:"",
  parentalConsent: false,
  enabled: true,
  hiringStage: "",
  primaryAddressStreet: "",
  primaryAddressStreetNumber: "",
  primaryAddressPostalCode: "",
  primaryAddressCity: "",
  primaryAddressCountry: "",
  secondaryAddressStreet: "",
  secondaryAddressStreetNumber: "",
  secondaryAddressPostalCode: "",
  secondaryAddressCity: "",
  secondaryAddressCountry: "",
  identityCardType: "",
  identityCardId: "",
  identityCardIssueDate: "",
  identityCardExpiryDate: "",
  issuedBy: "",
  issueLocation: "",
  employeePositions: "",
  employeeSoftSkills: "",
  employeeTrainings: "",
  employeeCommendations: "",
  employeeInfractions: "",
  employeeCertifications: "",
  employeeMedExams: "",
  employeeAbsences: "",
  missingTrainings: "",
  department: "",
  position: "",
  communicationByEmail: true,
  communicationBySMS: false,
  hiringCompany: "",
  timeCardId: "",
  timeCard: "",
  contractStatus: "",
  contractReference: "",
  latestContract: "",
  latestContractDisp: "",
  availableOnlyWorkingDays: false,
  availableOnlyWeekends: false,
  scheduleMinWeeklyHours: null,
  scheduleMaxWeeklyHours: null,
  scheduleRequiredDaysOffPerWeek: null,
  scheduleMaxConsecutiveWorkDays: null,
  employeeAvailabilities: "",
  employeeSkills: ""
}

export let commendationDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  weight: "",
  description: "",
  companySectionTypeList: []
}

export let infractionDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  weight: "",
  description: "",
  companySectionTypeList: []
};

export let workingTimeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  workingHours: "",
  description: ""
};

export let attractionDefault = {
  id: "",
  name: "",
  shortName: "",
  description: ""
};


export let zoneDefault = {
  id: "",
  name: "",
  shortName: "",
  description: "",
  rcpZoneType: "WORK",
  maxStayMinutes: "",
  countsAsBreak: false,
  active: true
};

export let nonWorkingDaysDefault = {
  selected: false,
  id: "",
  name: "",
  date: "",
  shortName: "",
  description: ""
};


export let businessPartnerDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  legalEntity:
    {id: 0},
  notes: "",
  nip: "",
  primaryPhone: "",
  primaryEmail: "",
  billingAddressStreet: "",
  billingAddressStreetNumber: "",
  billingAddressPostalCode: "",
  billingAddressCity: "",
  billingAddressCountry:
    {id: 0},
  secondaryAddressStreet: "",
  secondaryAddressStreetNumber: "",
  secondaryAddressPostalCode: "",
  secondaryAddressCity: "",
  secondaryAddressCountry:
    {id: 0},
  contactsIds : [],
  hiringCompany: false,
  active: true,
  commission: 0

};

export let countryDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: ""
};


export let voivodeshipDefault = {
  selected: false,
  id: "",
  name: ""
};



export let nfzBranchDefault = {
  selected: false,
  id: "",
  name: "",
  identifier: "",
  description: ""
};

export let legalEntityTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: ""
};

export let contractTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: "",
  color: "",
  legalPersonJuridical: false,
  legalPersonNatural: false,
  schedulePolicyType: "OTHER",
};


export let departmentDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: "",
  manager: {id: 0},
  deputyManager: {id: 0},
  positions: [],
  email: "",
  phoneNumber: "",
  color: "",
  vacationLimit: null,
  vacationLimitAction: "WARN",
  scheduleGenerationCriteria: "LOWEST_COST,HIGHEST_EVALUATION,FEWEST_WORKING_DAYS,PREFERRED_AVAILABILITY",
  defaultTargetColPercent: null,
  defaultTargetSpmh: null,
  defaultLaborHoursBudget: null,
  defaultMinimumStaff: null,
  defaultMaximumStaff: null,
  scheduleRequiredDaysOffPerWeek: null,
  scheduleMaxConsecutiveWorkDays: null,
  scheduleConsecutiveDaysWarningThreshold: null,
  scheduleDayOffMinimumAdvanceDays: null,
  scheduleVacationMinimumAdvanceDays: null,
  defaultDailyResourcePlanId: null,
  defaultWeekendResourcePlanId: null,
  defaultWeeklyResourcePlanId: null,
  defaultBiweeklyResourcePlanId: null,
  defaultMonthlyResourcePlanId: null
};


export let medicalExaminationTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: ""
};

export let genderDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: ""
};

export let trainingDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: "",
  required: false,
  formType: "OTHER"
  // positionTraining: false,
  // position: {id: 0}
};


export let documentTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: ""
};

export let identityCardTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: ""
};

export let certificationTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: "",
  expirationReminder: false,
  expirationReminderThreshold: 0
};


export let locationDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: ""
};

export let positionDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  basicWage: 0.0,
  basicNetWage: "",
  description: "",
  department: {id: 0},
  rcpZone: {id: 0},
  defaultLocation: {id: 0},
  active: true,
  requiredTrainings: [],
  requiredCertifications: []
};

export let positionTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: "",
};


export const equipmentOwnershipTypeDefault = {
  id: "",
  name: "",
  description: ""
}

export const equipmentStatusDefault = {
  id: "",
  name: ""
}

export const absenceTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: "",
  color: "",
  countsTowardVacationLimit: false
}

export const businessTripTypeDefault = {
  selected: false,
  id: "",
  name: "",
  shortName: "",
  description: ""
}

export const equipmentBookingStatusDefault = {
  id: "",
  name: "",
  description: "",
  color: ""
}

export const equipmentCategoryDefault = {
  id: "",
  name: "",
  description: ""
}

export let taxOfficeDefault = {
  selected: false,
  id: "",
  name: "",
  address: "",
  postalCode: "",
  city: "",
  code: "",
  voivodeship: {
    id: 0
  }
};

export const equipmentDefault = {
  id: 0,
  sortingId: 0,
  name: "",
  notes: "",
  width: 0,
  length: 0,
  height: 0,
  weight: 0,
  powerRequired: 0,
  staffNeeded: 0,
  minimumAge: 0,
  maxParticipants: 0,
  equipmentCategory: {
    id: 0
  },
  inUse: false,
  photos:[],
  equipmentStatus: {
    id: 0
  },
  bookingStatus: {
    id: 0
  },
  equipmentOwnership: {
    id: 0
  }
}

export const userCompactedDefault = {
  id: 0,
  login: "",
  password: "",
  firstName: "",
  lastName: "",
  userRoleDTOS: [],
  userRoles: [],
  enabled: true
}

export const userDefault = {
  id: 0,
  login: "",
  password: "",
  firstName: "",
  lastName: "",
  userRoleDTOS: [],
  userRoles: [],
  enabled: true
}

export const userRoleDefault = {
  id: "",
  name: "",
  description: ""
}


export const settingsDefault = {
  id: "",
  infractionWeightMinimumValue: 0,
  infractionWeightMaximumValue: 5,
  commendationWeightMinimumValue: 0,
  commendationWeightMaximumValue: 5,
  skillWeightMinimumValue: 0,
  skillWeightMaximumValue: 5,
  skillEvaluationMinimumValue: 0,
  skillEvaluationMaximumValue: 5,
  trainingEvaluationMinimumValue: 0,
  trainingEvaluationMaximumValue: 5,
  positionEvaluationDefaultValue: 3,
  positionEvaluationMinimumValue: 0,
  positionEvaluationMaximumValue: 5,
  employeeEvaluationSoftSkillsWeight: 1,
  employeeEvaluationPositionsWeight: 1,
  employeeEvaluationTrainingsWeight: 1,
  employeeEvaluationTrainingTestsWeight: 1,
  employeeEvaluationEventsWeight: 1,
  sameManagerInManyDepartments: false,
  employeeDocumentsRootPath: "",
  scheduleStatusAvailableColor: "",
  scheduleStatusWeekendOnlyColor: "",
  scheduleStatusFreeDaysOnlyColor: "",
  scheduleStatusNoContractColor: "",
  scheduleStatusAvailableFontColor: "",
  scheduleStatusWeekendOnlyFontColor: "",
  scheduleStatusFreeDaysOnlyFontColor: "",
  scheduleStatusNoContractFontColor: "",
  contractExpirationWarningDays: 0,
  scheduleEmploymentMinimumDailyRestHours: 11,
  scheduleEmploymentMinimumWeeklyRestHours: 35,
  scheduleDefaultRequiredDaysOffPerWeek: 2,
  scheduleDefaultMaxConsecutiveWorkDays: 7,
  scheduleConsecutiveDaysWarningThreshold: 5,
  scheduleWeeklyHoursWarningPercent: 90,
  scheduleTrainingTestMonthlyFailureLimit: 2,
  workTimeUnexcusedAbsenceAlertThreshold: 2,
  rcpLateToleranceMinutes: 5,
  rcpEarlyLeaveToleranceMinutes: 5,
  rcpMissingStartAlertMinutes: 15,
  rcpMaximumBreakMinutes: 30,
  scheduleDayOffMinimumAdvanceDays: 7,
  scheduleVacationMinimumAdvanceDays: 14,
  gangExportCharset: "WINDOWS-1250",
  gangExportDelimiter: ";",
  gangExportIncludeHeader: true,
  gangExportDateFormat: "yyyy-MM-dd",
  gangExportTimeFormat: "HH:mm",
  gangExportColumns: "EMPLOYEE_ID=PRACOWNIK_ID,LOGIN=LOGIN,PESEL=PESEL,CARD_ID=NR_KARTY,DATE=DATA,ENTRY_TYPE=TYP,PLANNED_START=PLAN_OD,PLANNED_END=PLAN_DO,ACTUAL_START=WEJSCIE,ACTUAL_END=WYJSCIE,BREAK_MINUTES=PRZERWA_MIN,WORKED_MINUTES=PRACA_MIN,DELTA_MINUTES=BILANS_MIN,LATE_MINUTES=SPOZNIENIE_MIN,EARLY_LEAVE_MINUTES=WCZ_WYJSCIE_MIN,OVERTIME_MINUTES=NADGODZINY_ZMIANOWE_MIN,ABSENCE_TYPE=NIEOBECNOSC,ATTENDANCE_STATUS=STATUS,SOURCE=ZRODLO",
  scheduleRuleOverrideRequireReason: true,
  certificationsExpirationCron: "",
  smtpHost: "",
  smtpPort: "",
  senderAddress: "",
  senderPassword: ""


}

export const companyDefault = {
  id: 0,
  fullName: "",
  shortName: "",
  regon: "",
  nip: "",
  krs: "",
  insuranceNumber: "",
  legalEntity: {id: 0},
  taxOffice: {id: 0},
  notes: "",
  representative: {id: 0},
  primaryStreet: "",
  primaryPostalCode: "",
  primaryCity: "",
  primaryCountry: {id: 0},
  secondaryStreet: "",
  secondaryPostalCode: "",
  secondaryCity: "",
  secondaryCountry: {id: 0},
  email: "",
  website: "",
  bankAccount: ""
}


export const resourcePlanManagerDefault = {
  id: 0,
  year: 0,
  weekNumber: 0,
  startOfWeek: "",
  endOfWeek: "",
  name: "",
  assignedDaysCount: 0,
  resourcePlanDay1: {id: 0},
  resourcePlanDay2: {id: 0},
  resourcePlanDay3: {id: 0},
  resourcePlanDay4: {id: 0},
  resourcePlanDay5: {id: 0},
  resourcePlanDay6: {id: 0},
  resourcePlanDay7: {id: 0}
}


export const resourcePlanItemDefault = {
  id: 0,
  department: {id: 0},
  positions: [],
  position: null,
  allOtherPositions: false,
  dayIndex: 1,
  requiredPeopleCount: 0,
  priority: 0,
  workStart: "",
  workEnd: "",
  active: "",
  createdAt: "",
  createdBy: "",
  updatedAt: "",
  updatedBy: ""

}

export const resourcePlanDefault = {
  id: 0,
  name: "",
  shortName: "",
  description: "",
  periodType: "DAILY",
  periodDays: 1,
  workStart: "",
  workEnd: "",
  resourcePlanItems: [],
  createdAt: "",
  createdBy: "",
  updatedAt: "",
  updatedBy: "",
  active: true,
  totalStaff: 0,
  totalHours: 0
}

